import OverlaySpinner from "components/common/loaders/OverlaySpinner";
import { redirectUrl } from "lib/utils/helpers";
import { errorToast } from "lib/utils/toasters";
import React, { useState } from "react";
import { ChevronRight } from "react-feather";
import { usePaymentContext } from "lib/contexts/PaymentProvider";
import { getRequest } from "lib/core/apiClient";
import { getUnApplicablePaymentReason } from "lib/utils/payments";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { analyticsEvents, analyticsTypes } from "lib/utils/constants";
import useSendAnalyticsEvent from "lib/hooks/useAnalytics";
import { useLocale } from "lib/hooks/useLocale";
import BajajIcon from "assests/images/bajaj.png";

const CustomPaymentCard: React.FC = ({}) => {
  const { t } = useLocale();
  const {
    state: { checkoutId, hasDefaultShippingHandleSelected },
    actions: { setCheckoutModal },
  } = useCheckoutContext();

  const {
    state: { paymentMethods },
  } = usePaymentContext();

  const { sendAnalyticsEvent } = useSendAnalyticsEvent();

  const customModeConfig = paymentMethods?.find((e: any) => e.mode === "CUSTOM_PAYMENT");
  const unapplicabilityReason = getUnApplicablePaymentReason(
    customModeConfig?.unavailability_reasons,
    customModeConfig?.metadata?.title,
  );

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleCustomPaymentClick = async () => {
    if (!Boolean(hasDefaultShippingHandleSelected)) {
      setCheckoutModal("SHIPPING_HANDLES");
      return;
    }

    try {
      sendAnalyticsEvent({
        eventName: analyticsEvents.FLO_PAYMENT_METHOD_SELECTED,
        eventFor: [analyticsTypes.SF_ANALYTICS, analyticsTypes.FACEBOOK_PIXEL],
        eventType: "click",
        metaData: {
          methodType: "CUSTOM_PAYMENT",
        },
      });
      setIsLoading(true);
      const response = await getRequest(`/checkout/${checkoutId}/custom-payment/initiate`, "KRATOS_PRIVATE");
      const success_url = response?.metadata?.action_urls?.CUSTOM_PAYMENT_TILE?.success_url;
      if (success_url) {
        redirectUrl(success_url);
      } else {
        throw new Error("Error while applying gift cards");
      }
    } catch (err) {
      errorToast(t("payment_error_generic"));
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="border-base overflow-hidden bg-white">
      <button
        className={`w-full ${customModeConfig?.is_available ? "cursor-pointer" : "cursor-not-allowed"}`}
        disabled={!customModeConfig?.is_available}
        onClick={() => {
          handleCustomPaymentClick();
        }}>
        <div
          className={`flex w-full  flex-row items-center justify-center space-x-2 p-3 ${
            customModeConfig?.is_available ? "text-coal-dark" : "text-gray-dark"
          }`}>
          <div className={`flex h-9 w-9 items-center justify-center`}>
            <img src={BajajIcon} alt="Bajaj" width={36} height={36} />
          </div>
          <div className="flex w-full flex-1 flex-col items-start justify-start space-y-1">
            <h3 className="text-sm font-medium">{customModeConfig?.metadata?.title ?? ""}</h3>
            {!Boolean(customModeConfig?.metadata?.hideDescription) && (
              <p className="text-left text-xs font-normal text-gray-dark">
                {customModeConfig?.metadata?.description ?? ""}
              </p>
            )}
          </div>

          {/* {!gcModeConfig?.is_available && (
            <span className="text-sm font-medium text-carbon-dark">{t("remove_offers")}</span>
          )} */}
          <ChevronRight className="h-4 w-4 text-coal-dark" />
        </div>
        {Boolean(!customModeConfig.is_available) && Boolean(unapplicabilityReason) && (
          <div className="bg-[#FAFAFA]">
            <p className="px-3 py-2 text-left text-xs font-normal text-gray-dark">{unapplicabilityReason}</p>
          </div>
        )}
      </button>
      {isLoading && <OverlaySpinner />}
    </div>
  );
};

export default CustomPaymentCard;
